import { all, takeEvery, put } from 'redux-saga/effects';
import { notification } from '@iso/components';
import actions from './actions';
import siteConfig from '@iso/config/site.config';
const gaxios = require('gaxios');
gaxios.instance.defaults = {
  baseURL: siteConfig.siteUrl.API_URL,
  headers: {
    Authorization: localStorage.getItem('access_token')
  }
}

const headers = {
  Authorization: localStorage.getItem('access_token'),
  AuthId: localStorage.getItem('id_token'),
  SiigoAuth: localStorage.getItem('siigo_token'),
}

export function* getInvoice(action) {
  let ULRDestino = `api/facturacion${action.query ? '?' + action.query : ""}`;
  console.log("traigo facturas", ULRDestino)
  // obtengo loadingInvoices

  const res = yield gaxios.request({
    url: ULRDestino,
    headers
  });

  console.log(res)

  if (res.data.success) {
    let newInvoices = res.data.facturas;
    if (!res.data.facturas[0]?.RecibosVinculadosObject) {
      newInvoices = res.data.facturas.map(item => {
        item.RecibosVinculadosObject = item.recibosVinculados
        return item;
      })
    }
    yield put({
      type: actions.UPDATE_INVOICE,
      invoices: newInvoices,
    });

    if (res.data.paginationInfo) {
      yield put({
        type: actions.SET_PAGINATION_INFO,
        payload: res.data.paginationInfo,
      });
    }

  } else {
    notification('error', res.data.msg);
  }
}

export function* deleteInvoice(action) {
  let ULRDestino = "api/facturacion/" + action.id;
  let metodo = "DELETE";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    data: {
      cajero: localStorage.getItem('id_token'),
      motivo: action.motivo || 'Anulación de factura',
    },
  });
  if (res.data.success) {
    notification('success', res.data.msg)
    yield put({
      type: actions.GET_INVOICE,
    });
  } else {
    notification('error', res.data.msg);
  }
}

export function* deleteHardInvoice(action) {
  let ULRDestino = "api/facturacion/completeDelete/" + action.id;
  let metodo = "DELETE";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
  });
  if (res.data.success) {
    notification('success', res.data.msg)
    yield put({
      type: actions.GET_INVOICE,
    });
  } else {
    notification('error', res.data.msg);
  }
}

export function* updateInvoiceSaga(action) {
  let ULRDestino = "api/facturacion/" + action.invoice._id;
  let metodo = "PUT";
  const res = yield gaxios.request({
    url: ULRDestino,
    data: action.invoice,
    method: metodo,
  });
  if (res.data.success) {
    notification('success', res.data.msg)
    yield put({
      type: actions.GET_INVOICE,
    });
    yield put({
      type: actions.SET_CURRENT_INVOICE,
      invoice: action.invoice,
    });
  } else {
    notification('error', res.data.msg);
  }
}

export function* saveInvoiceSaga(action) {
  let ULRDestino = "api/facturacion";
  let metodo = "POST";
  try {
    const res = yield gaxios.request({
      url: ULRDestino,
      data: {
        ...action.invoice,
        esContadorPrueba: process.env.NODE_ENV === 'development' ? true : false,
        cajero: localStorage.getItem('id_token'),
      },
      headers: {
        Authorization: localStorage.getItem('siigo_token')
      },
      method: metodo,
    });
    if (res.data.success) {
      yield put({
        type: actions.GET_INVOICE,
      });
      yield put({
        type: actions.SET_CURRENT_INVOICE,
        invoice: res.data.factura,
      });
      yield action.history.history.push('/dashboard/lista_ventas');
    } else {
      const mensaje = res.data?.error?.response?.data?.Errors[0]?.Message
      console.log(mensaje)
      notification('error', mensaje);
    }
  } catch (error) {
    console.log(error)
    notification('error', 'Error al guardar la factura. Por favor, inténtelo de nuevo.');
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_INVOICE, getInvoice),
    yield takeEvery(actions.UPDATE_EDIT_INVOICE, updateInvoiceSaga),
    yield takeEvery(actions.SAVE_INVOICE, saveInvoiceSaga),
    yield takeEvery(actions.DELETE_INVOICE, deleteInvoice),
    yield takeEvery(actions.DELETE_HARD_INVOICE, deleteHardInvoice),
  ]);
}